export default "__VITE_ASSET__B9KDKj$K__"